// src/app/core/utils/platform.ts
export const isBrowser = (): boolean =>
  typeof window !== 'undefined' && typeof document !== 'undefined';
